/**
 * Ticket: https://issue.sanitas.com/browse/FLEX-4715
 * Swagger: https://ovpv3.dev.gcp.sanet17.ch/swagger-ui/index.html#/feature-controller/getFeatureTogglz
 */

import useBackend from '@shared/hooks/useBackend'

import config from '@shared/config'

function featureFlag() {
  // HOOKS
  const { buildURL, doGet, setup } = useBackend()

  setup('/ovpv3/public', config.microserviceBaseUrl)

  async function getFeatureFlags() {
    const response = await doGet({ url: buildURL('/togglz') })

    return response.data
  }

  return {
    getFeatureFlags
  }
}

export default featureFlag()
